export function collapseWhitespace(html: string): string {
  // Collapse whitespace between tags
  let text = html.replace(/>\s+</g, '><');
  // Collapse all internal whitespace runs to single space
  text = text.replace(/\s+/g, ' ');
  return text;
}

export function stripTags(html: string): string {
  return html.replace(/<[^>]*>/g, '');
}

export function stripLineWhitespace(text: string): string {
  return text.replace(/^[ \t]+|[ \t]+$/gm, '');
}

export function decodeHtmlEntities(text: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');
  return doc.body.textContent ?? '';
}

export function collapseNewlines(text: string): string {
  return text.replace(/\n{3,}/g, '\n\n');
}

const EMOJI_REGEX = /\p{Emoji_Presentation}/gu;

export function stripEmoji(text: string): string {
  return text.replace(EMOJI_REGEX, '');
}

/**
 * Counts markup overhead characters in a Mobile.de formatted string.
 * Markup tokens: ** (bold), \\ (line break), * (bullet prefix).
 */
export function countMobileDeMarkupOverhead(mobileDeText: string): number {
  let stripped = mobileDeText;

  // Remove bold markers **
  stripped = stripped.replace(/\*\*/g, '');
  // Remove bullet prefixes "* " (preceded by start-of-string or \\)
  stripped = stripped.replace(/(?:^|(?<=\\\\))\* /g, '');
  // Remove line break tokens \\
  stripped = stripped.replace(/\\\\/g, '');

  return mobileDeText.length - stripped.length;
}
